import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { PagedCollectionQueryResult } from '@skylab-shared/business';
import { HttpService, IIdentifiable, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { Mutable } from '@skylab-shared/types';

export interface PurchaseDocumentUniqueOriginalNumberQueryProperties {
    requestParams: {
        externalDocumentNumber: string;
        clientName: string;
    };
    queryParams: {
        documentId?: number
    };
}

export class PurchaseDocumentUniqueOriginalNumberQuery extends Query<boolean> {
    public constructor(public readonly params: PurchaseDocumentUniqueOriginalNumberQueryProperties) {
        super();
    }
}
@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PurchaseDocumentUniqueOriginalNumberQuery)
export class PurchaseDocumentUniqueOriginalNumberQueryHandler implements QueryHandler<PurchaseDocumentUniqueOriginalNumberQuery, boolean> {
    #Url = TaggedUrl.join('purchase', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(query: PurchaseDocumentUniqueOriginalNumberQuery): Promise<boolean> {
        const { data } = await this.#http.get<Mutable<PagedCollectionQueryResult<IIdentifiable>>>(this.#Url, {
            params: { ...query.params.requestParams, pageSize: 50 }
        });
        if (data.items) {
            const documentId = query.params.queryParams.documentId;
            return documentId ? data.items.filter(x => x.id !== documentId).length === 0 : data.items.length === 0;
        } else return true;
    }
}
